import { createStore } from 'vuex';

export default createStore({
    state() {
        return {
            personal: null,
            roles: {},
            menus: []
        };
    },
    mutations: {
        setMenus(state, menus) {
            state.menus = menus;
        },
        setPersonal(state, personal) {
            state.personal = personal;
        },
        setRoles(state, roles) {
            state.roles = roles;
        }
    }
});
